export type Environment = "dev" | "staging" | "prod";
export type AppName = "care" | "portal";

// to add a property, also edit the env.d.ts file
type EnvironmentService = {
  appName: AppName;
  apiBaseUrl: string;
  amplitudeApiKey: string;
  auth0Audience: string;
  auth0ClientId: string;
  auth0Domain: string;
  auth0RedirectUri: string;
  baseUrl: string;
  cmsLinkWithEnv: string;
  environment: Environment;
  mediaStreamingDistributionUrl: string;
  sentryDsn: string;
  showDeveloperTools: boolean;
  downloadAppUrl: string;
  defaultMediaStreamingDistributionUrl: string;
}

type CareConfig = {
  motionCoachUrl: string;
  poseTrackingModelUrl: string;
  poseTrackingWasmUrl: string;
  bePublicApiKey: string;
}

type EnvironmentServiceCare = EnvironmentService & CareConfig;
type EnvironmentServicePortal = EnvironmentService;

const baseConfig = {
  appName: import.meta.env.VITE_APP_NAME as AppName,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  amplitudeApiKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  auth0Audience: import.meta.env.VITE_AUTH0_API_AUDIENCE,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0RedirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI,
  baseUrl: import.meta.env.VITE_BASE_URL,
  cmsLinkWithEnv: import.meta.env.VITE_CMS_LINK_WITH_ENV,
  environment: import.meta.env.VITE_ENVIRONMENT as Environment,
  mediaStreamingDistributionUrl: import.meta.env.VITE_MEDIA_STREAMING_DISTRIBUTION_URL,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  showDeveloperTools: import.meta.env.VITE_SHOW_DEVELOPER_TOOLS === "true",
  downloadAppUrl: import.meta.env.VITE_DOWNLOAD_APP_URL,
  defaultMediaStreamingDistributionUrl: import.meta.env.VITE_DEFAULT_MEDIA_STREAMING_DISTRIBUTION_URL,
} satisfies EnvironmentService;

const careConfig = {
  motionCoachUrl: import.meta.env.VITE_MOTION_COACH_URL,
  poseTrackingModelUrl: import.meta.env.VITE_POSE_TRACKING_MODEL_URL,
  poseTrackingWasmUrl: import.meta.env.VITE_POSE_TRACKING_WASM_URL,
  bePublicApiKey: import.meta.env.VITE_BE_PUBLIC_API_KEY,
} satisfies CareConfig;

export const sharedEnvironment = {
  ...baseConfig,
} satisfies EnvironmentService;

export const careEnvironment = {
  ...baseConfig,
  ...careConfig,
} satisfies EnvironmentServiceCare;

export const portalEnvironment = {
  ...baseConfig,
} satisfies EnvironmentServicePortal;
